import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy route. The pending/drafts UI is now an embedded tab inside
 * /dashboard so it shares the same shell, header and navigation. We keep
 * this file only to redirect old bookmarks back into the dashboard.
 */
export const Route = createFileRoute("/dashboard/pending")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
  component: () => null,
});
